module.exports = __webpack_public_path__ + "img/new-market.61479853.svg";